import axios from 'axios';
import { env } from '../../config/env';

if (!env.api.WORKER_API_URL) {
    throw new Error('VITE_WORKER_API_URL is not configured. Set it in your .env file.');
}

const baseURL = `${env.api.WORKER_API_URL.replace(/\/+$/, '')}/api/`;

export const workerClient = axios.create({
    baseURL,
    timeout: 10000,
    headers: {
        'Content-Type': 'application/json',
        'Accept': 'application/json',
    },
});

export default workerClient;
